import React, { useEffect, useState } from "react";
import axios from "axios";
import { dashboardURL } from "../../Config/Url";
import { useTranslation } from "react-i18next";
import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import WhiteLoader from "../Common/WhiteLoader";

const TotalNumberOfUsers = () => {
  const [totalNumberOfUsers, setTotalNumberOfUsers] = useState([]);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingNum, setIsLoadingNum] = useState(false);

  let config = {
    headers: {
      "X-IsMockup": false,
    },
  };

  useEffect(() => {
    axios
      .get(`${dashboardURL}/total-number-of-users`, config)
      .then((result) => {
        setTotalNumberOfUsers(result.data.totalNumber);
        setIsLoading(false);
      })
      .catch((err) => console.log(err.response));
    if (localStorage.getItem("liveReload") === "true") {
      setIsLoading(false);
      const interval = setInterval(() => {
        setIsLoadingNum(true);
        axios
          .get(`${dashboardURL}/total-number-of-users`, config)
          .then((result) => {
            setTotalNumberOfUsers(result.data.totalNumber);
            setIsLoadingNum(false);
          })
          .catch((err) => console.log(err.response));
      }, 30000);
      return () => clearInterval(interval);
    } else {
      axios
        .get(`${dashboardURL}/total-number-of-users`, config)
        .then((result) => {
          setTotalNumberOfUsers(result.data.totalNumber);
          setIsLoading(false);
        })
        .catch((err) => console.log(err.response));
    }
  }, []);

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <>
          <Card.Body className="dashboard-card-body-user">
            <div className="dashboard-card-body-user-image">
              <span className="icon icon-group" style={{ fontSize: 85 }}></span>
            </div>
            <div className="dashboard-card-body-user-simpleData">
              {isLoadingNum ? <WhiteLoader /> : totalNumberOfUsers}
            </div>
          </Card.Body>
          <Card.Footer className="dashboard-card-footer-user">
            {translator("Dashboard-TotalNumberOfUsers-Title")}
          </Card.Footer>
        </>
      )}
    </>
  );
};

export default TotalNumberOfUsers;
